import moment from 'moment';
import { LOCATION_CHANGE } from 'connected-react-router';
import {
    CRUD_CREATE_SUCCESS,
    CRUD_CREATE_FAILURE,
    CRUD_GET_ONE_SUCCESS
} from 'store/actions/dataActions';
import { REFRESH_VIEW } from 'store/actions/listActions';
import { 
    DATE_FORMAT_ALL,
} from 'util/constants';

const initialState = {};
let previousPathname = '';

// 에러 error 부분 계속 유지해야하나?? 다른 곳으로 옮겨야하나??? reloading 부분 때문에 현재는 옮길 수 없다
export default (previousState = initialState, { type, payload, requestPayload, meta, error }) => {

    switch (type) {
        case LOCATION_CHANGE://다른 메뉴로 이동하는 경우 구조가 달라 에러발생하므로 초기화
            if( previousPathname !== '' && previousPathname !== payload.location.pathname && payload.location.isKeepItem !== true ) {
                previousPathname = payload.location.pathname;
                return initialState;
            } else {
                previousPathname = payload.location.pathname;
                return previousState;
            }

        case CRUD_CREATE_SUCCESS:
            if( meta.menu === 'DOCUMENT.FILE.REGISTRATION' ||  meta.menu === 'DOCUMENT.FILE.DEIDENTIFICATION' ) {
                return { ...payload }
            }

            return previousState;

        case CRUD_GET_ONE_SUCCESS:
            if( meta.menu === 'DOCUMENT.FILE') {

                let date = null;
                if( payload.date ) {
                    date = moment(payload.date).format(DATE_FORMAT_ALL);
                }
                let searchCond = payload.highlightTag ? payload.highlightTag.replace(/<[^>]+>/g, '') : '';
                let tags = payload.tags.map((tag, index) => ({
                    key: index,
                    id: tag.id,
                    label: tag.name,
                    highlight: tag.name === searchCond
                }))
                let locations = payload.locations.map((location, index) => ({
                    key: index,
                    id: location.id,
                    label: location.name,
                    highlight: false
                }))
                let persons = payload.persons.map((person, index) => ({
                    key: index,
                    id: person.id,
                    label: person.name,
                    highlight: false
                }))
                let organizations = payload.organizations.map((organization, index) => ({
                    key: index,
                    id: organization.id,
                    label: organization.name,
                    highlight: false
                }))
                let dates = payload.dates.map((date, index) => ({
                    key: index,
                    id: date.id,
                    label: date.name,
                    highlight: false
                }))

                return { 
                    document: {
                        ...payload,
                        content: payload.content ? payload.content : '',
                        fileName: payload.fileName ? payload.fileName : '',
                        date: date,
                        tags,
                        locations,
                        persons,
                        organizations,
                        dates
                    }
                };

            }
            
            return previousState;

        case CRUD_CREATE_FAILURE:
            if( meta.menu === 'DOCUMENT.FILE.REGISTRATION' ||  meta.menu === 'DOCUMENT.FILE.DEIDENTIFICATION' ) {
                return (error && error.body) || {} ;
            }
            return previousState;

        case REFRESH_VIEW:
            return initialState;
    
        default:
            return previousState;
    }
    
};
